import UpdateUser from './containers/UpdateUser';
import DetailUser from './containers/DetailUser';
import CreateUser from './containers/CreateUser';

export default UpdateUser;
export { DetailUser, CreateUser };
